import {
  ADD_COMPANY_CONTACT_FAILED,
  ADD_COMPANY_CONTACT_SUCCESS,
  ADD_COMPANY_FAILED,
  ADD_COMPANY_SUCCESS,
  CONFIRMED_GET_COMPANIES,
  CONFIRMED_GET_COMPANIES_CONTACT,
  CONFIRMED_GET_COMPANY,
  GET_COMPANIES_CONTACT_FAILED_ACTION,
  GET_COMPANIES_FAILED_ACTION,
  UPDATE_COMPANY_FAILED,
  UPDATE_COMPANY_SUCCESS,
} from "../../actions/Companies/companyTypes";

const initialState = {
  companies: [],
  companyContacts: [],
  selectedCompany: {},
  errorMessage: "",
  successMessage: "",
  showLoading: false,
};

export function CompanyReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_COMPANIES:
      return {
        ...state,
        companies: action.payload,
        showLoading: false,
      };

    case CONFIRMED_GET_COMPANIES_CONTACT:
      return {
        ...state,
        companyContacts: action.payload,
        showLoading: false,
      };

    case GET_COMPANIES_CONTACT_FAILED_ACTION:
    case GET_COMPANIES_FAILED_ACTION:
    case ADD_COMPANY_FAILED:
    case ADD_COMPANY_CONTACT_FAILED:
    case UPDATE_COMPANY_FAILED:
      return {
        ...state,
        errorMessage: action.payload,
        successMessage: "",
        showLoading: false,
      };

    case ADD_COMPANY_SUCCESS:
    case ADD_COMPANY_CONTACT_SUCCESS:
    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        errorMessage: "",
        successMessage: action.payload,
        showLoading: false,
      };

    case CONFIRMED_GET_COMPANY:
      return {
        ...state,
        errorMessage: "",
        successMessage: "",
        selectedCompany: action.payload,
        showLoading: false,
      };

    default:
      return state;
  }
}
